import { useConfig } from '../../../providers/envConfig'
import useFetch from '../../helpers/useFetch'

export type GenerateCodeResponse = {
  message: string
  success: boolean
}

// usePostGenerateCode is a custom hook to fetch data from the /verification/generate-code endpoint.
const usePostGenerateCode = (id: string) => {
  const envConfig = useConfig()

  const url = `${envConfig.vpcUrl}/verification/generate-code`
  const fields: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-BNET-KEY': envConfig.bnetKey,
    },
    credentials: 'include',
    body: JSON.stringify({ id: id }),
  }

  const { data, loading, error, callFetch, headers } = useFetch<GenerateCodeResponse>(url, fields)

  return { data, loading, error, callFetch, headers }
}

export default usePostGenerateCode
